import * as BABYLON from 'babylonjs';
import * as GUI from 'babylonjs-gui';
import 'babylonjs-loaders';
import VisualComponent from './VisualComponent';
import axios from 'axios';

class URLButton extends VisualComponent {
    getType() { return "URLButton"; }

    constructor( { id } = {} ) {
        super( { id });
    }

    construct( context, prefab ) {
        this.base = super.construct( context, prefab );
        
        this.deactivateButton = false;
        this.context = context;
        this.prefab = prefab;

        if(this.prefab.getURL().includes("https://"))
            this.constructURLButton();
        else
            this.initPlusMenu();
    }
        
    constructURLButton(){
        this.base.getChildMeshes().forEach(mesh => {
            mesh.renderingGroupId = 3;
        });

        if(this.prefab.getURL()) {
            var url = this.prefab.getURL();
           
            this.mesh.actionManager = new BABYLON.ActionManager(this.scene);
            this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, () => {
                if(this.prefab.getdisplayInternally() == "true" && this.prefab.getURL() != "https://www.denios.de/unternehmen/denios-entdecken/ueber-denios/"){
                    window.dispatchEvent(new CustomEvent("openURL", {detail:{type: this.prefab.getURL().includes(".mp4") ? "Video" : "Website", content: {url: url}}}));
                }else{
                    window.open(url, "_blank");                  
                }     
            }));

            var ease = new BABYLON.CubicEase();
            ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
            this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, () => {
                BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "scaling", 30,10, this.mesh.scaling, new BABYLON.Vector3.One(), 0, ease);  
            }));

            this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, () => {
                BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "scaling", 30,10, this.mesh.scaling, new BABYLON.Vector3.One().scale(1.1), 0, ease);
            }));
        }

        return this.base;
    }

    addPulseAnimation(){
        var ease = new BABYLON.CubicEase();
        ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
        
        // Pulse Animation
        const frameRate = 10;
        const pulse = new BABYLON.Animation("pulse", "scaling", frameRate, BABYLON.Animation.ANIMATIONTYPE_VECTOR3, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
        pulse.setEasingFunction(ease);
        const keyFrames = []; 
        keyFrames.push({frame: 0, value: new BABYLON.Vector3(1,1,1)});
        keyFrames.push({frame: frameRate, value: new BABYLON.Vector3(1.15,1.15,1.15)});
        keyFrames.push({frame: 2 * frameRate, value: new BABYLON.Vector3(1,1,1)});
        pulse.setKeys(keyFrames);
        this.mesh.animations.push(pulse);
        window.scene.beginAnimation(this.mesh, 0, 2 * frameRate, true);
    }

    async initPlusMenu(){
        GUI.Control.prototype.getScene = () => { return window.scene };

        this.ease = new BABYLON.CubicEase();
        this.ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);

        this.mesh.dispose();

        this.base.position = this.prefab.getPosition();
        this.base.position = this.base.position.multiply(new BABYLON.Vector3(0.8,0.8,0.8));

        if((this.prefab.getRotationX() && this.prefab.getRotationX() != 0) || (this.prefab.getRotationY() && this.prefab.getRotationY() != 0) || (this.prefab.getRotationZ() && this.prefab.getRotationZ() != 0)){
            this.base.rotation = new BABYLON.Vector3(this.prefab.getRotationX()* Math.PI / 180, this.prefab.getRotationY()* Math.PI / 180, this.prefab.getRotationZ()* Math.PI / 180);
        }else{
            this.base.lookAt(new BABYLON.Vector3(0,0,0));
        }
        
        let pointerDown = false;
        window.scene.onPointerDown = () => {
            pointerDown = true;
        }
        window.scene.onPointerUp = () => {
            pointerDown = false;
        }
        window.scene.onPointerMove = () => {
            if(pointerDown){
                window.dispatchEvent(new CustomEvent("closeOtherProductMenus", {detail: {this: this}}));
                window.dispatchEvent(new CustomEvent("closeAllTextElements", {detail: {this: undefined}}));
            }
        }

        // Case: Language & region in url defined
        if(this.context.activeLanguage)
            this.constructPlusMenu();
            
        window.addEventListener("languageChange", () => {
            this.constructPlusMenu();
        });

        return this.base;
    }

    async constructPlusMenu(){
        this.destroyOldMenu();
        
        this.products = await this.getProducts();
        let product = this.products.find(product => product.sku == this.prefab.getURL());
        console.log("Produkt Daten("+this.prefab.getURL()+"):",product);
        let data = product;
        if(!data){
            this.contents = await this.getContents();
            let content = this.contents.find(content => content.name == this.prefab.getURL());
            console.log("Content Data("+this.prefab.getURL()+"):",content);
            data = content[this.context.activeLanguage.shortCode + "-" + this.context.activeRegion.id];
        }

        if((data.noShop || !data.viewer3D) && JSON.stringify(data) !== '{}'){
            // console.log("Data available for :",data);
            this.createMainButton();
            this.createSubMenue();
            return;
        } else if(data && JSON.stringify(data) === '{}'){
            // console.log("Data not available for:",data);
            this.constructNotAvailableMenu();
            return;
        }


        // Get product json from server
        if(!this.productData)
            this.productData = await this.getProductData(this.prefab.getURL());

        // Check if product is available in this region. If not display message not available
        if((this.productData && this.productData.masterData.current.name[this.context.activeLanguage.shortCode + "-" + this.context.activeRegion.id])){
            // console.log("Data available for :",data);
            this.createMainButton();
            this.createSubMenue();
        }else{
            // console.log("Data not available for:",data);
            this.constructNotAvailableMenu();
        }
    }

    constructNotAvailableMenu(){
        // console.log("Context:",this.context);
        // console.log("Prefab:",this.prefab);

        this.mainButton = BABYLON.MeshBuilder.CreatePlane("MainButton", {height: 30, width: 30, sideOrientation: BABYLON.Mesh.DOUBLESIDE} , window.scene);
        this.mainButton.parent = this.base;
        this.mainButton.rotation.y = Math.PI;
        this.mainButton.position.y = 12;
        this.mainButton.visibility = 1;

        let grid = new GUI.Grid("Root Grid");
        grid.addRowDefinition(0.8);
        grid.addRowDefinition(0.2);

        var specialText = this.prefab.situation == 405706 ? "Nicht verfügbar_digitalService" : "Nicht verfügbar" 
        let text = new GUI.TextBlock("Text",this.context.$i18n.t(specialText));
        text.fontSize = "36x";
        text.fontFamily = "Roboto";
        text.fontWeight = "240";
        text.color = "white";
        text.textWrapping = true;
        text.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        text.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
        text.paddingBottom = "50px";
        grid.addControl(text,0);

        let image = new GUI.Image("", this.context.publicPath+"/media"+this.context.$store.getters.mediaURL+"/data/icons/icMenuDisabled.svg");
        image.width = "20%";
        image.height = "100%";
        image.alpha = 0.2;
        grid.addControl(image,1);

        let advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(this.mainButton, 512, 512);
        advancedTexture.addControl(grid);
    }

    destroyOldMenu(){
        if(this.mainButton){
            console.log("Destroying MainButton")
            this.mainButton.dispose();
            this.mainButton.material.dispose();
        }

        if(this.subMenue){
            console.log("Destroying SubMenu")
            this.subMenue.dispose();
            this.subMenue.material.dispose();
        }
    }

    createMainButton(){
        this.material.emissiveTexture.dispose();
        this.material.dispose();
        
        console.log("Create MainButton")

        this.mainButton = BABYLON.MeshBuilder.CreatePlane("MainButton", {height: 6, width: 6, sideOrientation: BABYLON.Mesh.DOUBLESIDE} , window.scene);
        this.mainButton.parent = this.base;
        this.mainButton.rotation.y = Math.PI;

        let image = new GUI.Image("", this.context.publicPath+"/media"+this.context.$store.getters.mediaURL+"/data/icons/icMenuOpen.svg");
        image.width = "99%";
        image.height = "99%";

        let button = new GUI.Button();
        button.thickness = 0;
        button.hoverCursor = "pointer";
        button.onPointerDownObservable.add(() => {
            if(!this.context.followModeratorMode && !this.deactivateButton){
                this.deactivateButton = true;

                window.dispatchEvent(new CustomEvent("closeOtherProductMenus", {detail: {this: this}}));
                window.dispatchEvent(new CustomEvent("closeAllTextElements", {detail: {this: undefined}}));
                
                if(this.subMenue){
                    if(this.subMenue.isEnabled()){
                        this.closeMenu(); 
                    }else{
                        this.openMenu();
                    } 
                }
            }
        });
        button.onPointerOutObservable.add(() => {
            BABYLON.Animation.CreateAndStartAnimation("", this.mainButton, "scaling", 30,7, this.mainButton.scaling, new BABYLON.Vector3.One(), 0, this.ease);  
        });
        button.onPointerEnterObservable.add(() => {
            BABYLON.Animation.CreateAndStartAnimation("", this.mainButton, "scaling", 30,7, this.mainButton.scaling, new BABYLON.Vector3.One().scale(1.2), 0, this.ease);
        });	
        button.addControl(image);

        let advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(this.mainButton, 128, 128);
        advancedTexture.addControl(button);

        window.addEventListener("closeOtherProductMenus", (e) => {
            if(this.subMenue && e.detail.this != this && this.subMenue.isEnabled() && !this.deactivateButton)
                this.closeMenu();
        });
    }

    async createSubMenue(){
        console.log("Create SubMenu")

        this.subMenue = BABYLON.MeshBuilder.CreatePlane("SubMenu", {height: 40, width: 40, sideOrientation: BABYLON.Mesh.DOUBLESIDE}, window.scene);
        this.subMenue.parent = this.base;
        this.subMenue.rotation.y = Math.PI;
        this.subMenue.setEnabled(false);
        this.subMenue.renderingGroupId = 2;

        let grid = new GUI.Grid("Root Grid");
        grid.height = "70%";
        grid.width = "100%";
        grid.addRowDefinition(0.25);
        grid.addRowDefinition(0.25);
        grid.addRowDefinition(0.25);
        grid.addRowDefinition(0.25);

        let advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(this.subMenue, 512, 512);
        advancedTexture.addControl(grid);

        // Get product data from products.json via sku
        let data = this.products.find(product => product.sku == this.prefab.getURL());
        let name = undefined;

        // If product not in products.json check content.json
        if(!data){
            data = this.contents.find(data => data.name == this.prefab.getURL())[this.context.activeLanguage.shortCode + "-" + this.context.activeRegion.id]
            name = this.contents.find(data => data.name == this.prefab.getURL()).name;
        }

        if(data.viewer3D){
            if(data.viewer3D.length > 1){
                data.viewer3D.forEach(viewer3D => {
                    grid.addControl(this.createSubMenueButton({type: "Produkte", content: viewer3D, sku: viewer3D.sku, skuAlt: viewer3D.skuAlt, noShop: false}),grid.children.length);
                });
            }else{
                grid.addControl(this.createSubMenueButton({type: "Produkte", content: data.viewer3D, sku: data.sku, skuAlt: data.skuAlt, noShop: data.noShop}),grid.children.length);
            }
        }

        let dataset = this.products.concat(this.contents);
        if(!data.noShop && dataset.find(data => data.sku == this.prefab.getURL()))
            grid.addControl(this.createSubMenueButton({type: "Bildergalerie", sku: data.sku}),grid.children.length);
        
        let documents = await this.getDocuments(data.sku);
        if(documents && documents[0].id != "undefined" && documents[0].src)
            grid.addControl(this.createSubMenueButton({type: "Dokumente", content: documents, sku: data.sku}),grid.children.length);
            
        if(data.videoGallery || typeof data.video === 'array')
            grid.addControl(this.createSubMenueButton({type: "Videothek", content: data.videoGallery, sku: data.sku}),grid.children.length);

        if(data.informationPDF || typeof data.informationPDF === 'string')
            grid.addControl(this.createSubMenueButton({type: "InformationPDF", content: data.informationPDF, name: name}),grid.children.length);

        if(data.website || typeof data.website === 'string'){
            console.log("Add Website-Submenu with:",data.website);
            if(data.website.length > 1){   
                data.website.forEach(website => {
                    grid.addControl(website.url!=''?this.createSubMenueButton({type: "Website", content: website.url, name: name}):this.createNotAvailableSubMenueButton("Website"),grid.children.length);
                });
            }else{
                grid.addControl(data.website.url!=''?this.createSubMenueButton({type: "Website", content: data.website.url, name: name}):this.createNotAvailableSubMenueButton("Website"),grid.children.length);
            }
        }

        if(data.video || typeof data.video === 'string'){
            grid.addControl(data.video === '' ? this.createNotAvailableSubMenueButton("Video"):this.createSubMenueButton({type: "Video", content: {url: data.video}, name: name}),grid.children.length);
        }

        if(data.schadensfall || typeof data.schadensfall === 'string')
            grid.addControl(this.createSubMenueButton({type: "Schadensfall", content: data.schadensfall, name: name}),grid.children.length);

        if(data.shop || typeof data.shop === 'string')
            grid.addControl(data.shop!=''?this.createSubMenueButton({type: "Shop", content: data.shop, name: name}):this.createNotAvailableSubMenueButton("Shop"),grid.children.length);


        this.subMenue.position.y = (4 - grid.children.length) * -3.5;
    }

    createSubMenueButton(data){
        let rectangle = new GUI.Rectangle("Rectangle");
        rectangle.hoverCursor = "pointer";
        rectangle.thickness = 4;
        rectangle.height = "85%";
        rectangle.background = "#ffffffb4";
        rectangle.color = "#2061AE";
        rectangle.fontSize = "30px";
        rectangle.fontFamily = "Roboto"
        rectangle.fontWeight = "600";
        rectangle.alpha = 0.8;
        rectangle.onPointerDownObservable.add(() => {
            if(data.type == "Bildergalerie" || data.type == "Dokumente" || data.type == "Videothek")
                window.dispatchEvent(new CustomEvent("openURL", {detail: {type: data.type, content: data.content, sku: data.sku}}));

            if(data.type == "Produkte")    
                window.dispatchEvent(new CustomEvent("openViewer3D", {detail: {content: data.content, sku: data.sku, skuAlt: data.skuAlt, noShop: data.noShop}}));

            if(data.type == "InformationPDF" || data.type == "Video" || data.type == "Schadensfall")
                window.dispatchEvent(new CustomEvent("openURL", {detail: {type: data.type, content: data.content, name: data.name}}));

            if(data.type == "Website" || data.type == "Shop")
                window.open(data.content, '_blank').focus();
            
            BABYLON.Animation.CreateAndStartAnimation("", rectangle, "alpha", 60,20, 1, 1, 0, this.ease);  
        });
        rectangle.onPointerOutObservable.add(() => {
            BABYLON.Animation.CreateAndStartAnimation("", rectangle, "alpha", 60,10, rectangle.alpha, 0.8, 0, this.ease);  
        });
        rectangle.onPointerEnterObservable.add(() => {
            BABYLON.Animation.CreateAndStartAnimation("", rectangle, "alpha", 60,10, rectangle.alpha, 1, 0, this.ease);  
        });	

        let grid = new GUI.Grid("Grid");
        grid.fontSize = "30px";
        grid.fontFamily = "Roboto"
        grid.fontWeight = "600";
        grid.paddingLeft = "30px";
        grid.paddingRight = "20px";
        grid.paddingTop = "10px";
        grid.paddingBottom = "10px";
        grid.addColumnDefinition(0.1);
        grid.addColumnDefinition(0.9);
        rectangle.addControl(grid);
        
        let imageURL = this.context.publicPath + "/media"+this.context.$store.getters.mediaURL+"/data/icons/";
        if(data.type == "Bildergalerie")
            imageURL += "icPhotos.svg";
        if(data.type == "Videothek")
            imageURL += "icVideo.svg";
        if(data.type == "Dokumente")
            imageURL += "icDocuments.svg";
        if(data.type == "Produkte")
            imageURL += "icProductView.svg";

        if(data.type == "InformationPDF")
            imageURL += "icDocuments.svg";
        if(data.type == "Website")
            imageURL += "icWebsite.svg";
        if(data.type == "Video")
            imageURL += "icPlay blue.svg";
        if(data.type == "Schadensfall")
            imageURL += "icDocuments.svg";
        if(data.type == "Shop")
            imageURL += "icShop blue.svg";
        
        let icon = new GUI.Image("Icon",imageURL);
        icon.width = "75px";
        icon.height = "75px";
        icon.scaleX = 0.6;
        icon.scaleY = 0.6;
        grid.addControl(icon,0,0);

        let name;
        if(data.type == "Bildergalerie")
            name = "Bildergalerie öffnen";
        if(data.type == "Videothek")
            name = "Videothek ansehen";
        if(data.type == "Dokumente")
            name = "Dokumente downloaden";
        if(data.type == "Produkte")
            name = "Produkte erleben";
        if(data.type == "InformationPDF")
            name = "Weitere Informationen";
        if(data.type == "Website")
            name = "Website öffnen";
        if(data.type == "Video")
            name = "Video ansehen";
        if(data.type == "Schadensfall")
            name = "Schadensfall ansehen";
        if(data.type == "Shop")
            name = "Shop öffnen";
       
        let text = new GUI.TextBlock("Text",this.context.$i18n.t(name));
        text.fontSize = "30px";
        text.fontFamily = "Roboto"
        text.fontWeight = "600";
        text.color = "#2061AE";
        text.paddingLeft = "20px";
        text.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        grid.addControl(text,0,1);

        window.addEventListener("languageChange", () => {
            text.text = this.context.$i18n.t(name);
        });

        return rectangle;
    }

    createNotAvailableSubMenueButton(buttonType){
        console.log("Create NotAvailable-Button for Type:",buttonType);
        let rectangle = new GUI.Rectangle("Rectangle");
        rectangle.hoverCursor = "pointer";
        rectangle.thickness = 7;
        rectangle.height = "85%";
        rectangle.background = "#ffffff44";
        rectangle.color = "#44444444";
        rectangle.fontSize = "30px";
        rectangle.fontFamily = "Roboto"
        rectangle.fontWeight = "600";

        let grid = new GUI.Grid("Grid");
        grid.fontSize = "30px";
        grid.fontFamily = "Roboto";
        grid.fontWeight = "600";
        grid.paddingLeft = "30px";
        grid.paddingRight = "20px";
        grid.paddingTop = "10px";
        grid.paddingBottom = "10px";
        grid.addColumnDefinition(0.1);
        grid.addColumnDefinition(0.9);
        rectangle.addControl(grid);

        let imageURL = this.context.publicPath + "/media"+this.context.$store.getters.mediaURL+"/data/icons/";
        if(buttonType == "Bildergalerie")
            imageURL += "icPhotos.svg";
        if(buttonType == "Videothek")
            imageURL += "icVideo.svg";
        if(buttonType == "Dokumente")
            imageURL += "icDocuments.svg";
        if(buttonType == "Produkte")
            imageURL += "icProductView.svg";
        if(buttonType == "InformationPDF")
            imageURL += "icDocuments.svg";
        if(buttonType == "Website")
            imageURL += "icWebsite.svg";
        if(buttonType == "Video")
            imageURL += "icPlay blue.svg";
        if(buttonType == "Schadensfall")
            imageURL += "icDocuments.svg";
        if(buttonType == "Shop")
            imageURL += "icShop blue.svg";
        
        let icon = new GUI.Image("Icon",imageURL);
        icon.width = "150px";
        icon.height = "150px";
        icon.scaleX = 0.6;
        icon.scaleY = 0.6;
        icon.alpha = 0.3;
        grid.addControl(icon,0,0);

        let text = new GUI.TextBlock("Text",this.context.$i18n.t("Nicht verfügbar"));
        text.fontSize = "60px";
        text.fontFamily = "Roboto"
        text.fontWeight = "600";
        text.color = "#44444444";
        text.paddingLeft = "20px";
        text.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        grid.addControl(text,0,1);

        window.addEventListener("languageChange", () => {
            text.text = this.context.$i18n.t(name);
        });

        return rectangle;
    }

    closeMenu(){
        BABYLON.Animation.CreateAndStartAnimation("", this.mainButton, "rotation.z", 60,30, this.mainButton.rotation.z, 0, 0, this.ease);
        BABYLON.Animation.CreateAndStartAnimation("", this.subMenue, "visibility", 60,30, 1, 0, 0, this.ease);
        BABYLON.Animation.CreateAndStartAnimation("", this.subMenue, "position.x", 60,30, -26, -24, 0, this.ease,() => {
            this.subMenue.setEnabled(false);
            this.deactivateButton = false;

            // Get all Rectangles from Submenu and set alpha to 1 (no transparent buttons when menu opens)
            let rectangles = this.subMenue.material.emissiveTexture.getControlByName("Root Grid").children;
            rectangles.forEach(rectangle => {
                rectangle.alpha = 1;
            });
        });
    }

    openMenu(){
        this.subMenue.setEnabled(true);
        BABYLON.Animation.CreateAndStartAnimation("", this.mainButton, "rotation.z", 60,30, this.mainButton.rotation.z, -Math.PI/4, 0, this.ease);
        BABYLON.Animation.CreateAndStartAnimation("", this.subMenue, "visibility", 60,30, 0, 1, 0, this.ease);
        BABYLON.Animation.CreateAndStartAnimation("", this.subMenue, "position.x", 60,30, -24, -26, 0, this.ease,() => {
            this.deactivateButton = false;
        });
    }
    
    // Get PDF Documents from Denios documentservice
    async getDocuments(sku){
        if(sku != undefined){
            let documents = await axios("https://documentservice.production.denios.io/?skus=" + sku, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            }).catch(() => {
                console.log("ERROR: There is a problem ("+sku+")");
            });
            
            if(documents){
                documents = documents.data.replaceAll("'",'"');
                documents = JSON.parse(documents);
                console.log(sku + " ->",documents);
                return documents;
            }
        }

        return undefined;
    }

    async getProductData(sku){
        let tokenData = await axios("https://auth.europe-west1.gcp.commercetools.com/oauth/token?grant_type=client_credentials", {
            method: 'POST',
            headers: {
                'Authorization': 'Basic czRuMTNzUjNqUnBpSUUzMmN3VnI5TzhmOkl4VVBkbDhiUEtEMWpNOE0xalNZUjBiWkFNR1BPVlhp'
            }
        }).catch(() => {
            console.log("error");
        });

        let productData = await axios("https://api.europe-west1.gcp.commercetools.com/denios_develop/products/key=" + sku, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + tokenData.data.access_token
            }
        }).catch(() => {
            console.log("error");
        });

        if(productData)
            return productData.data

        return undefined;
    }

    async getProducts(){
        try {
            const response = await fetch(process.env.BASE_URL + "/media" + this.context.$store.getters.mediaURL + "/data/Products/Products.json");
            if (!response.ok) {
                throw new Error('Fehler beim Abrufen der products-Daten.', response);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Fehler beim Abrufen der products-Daten:', error);
            return [];
        }
    }

    async getContents(){
        try {
            const response = await fetch(process.env.BASE_URL + "/media" + this.context.$store.getters.mediaURL + "/data/Digital Services/Content.json");
            if (!response.ok) {
                throw new Error('Fehler beim Abrufen der contents-Daten.', response);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Fehler beim Abrufen der contents-Daten:', error);
            return [];
        }
    }
}

export default URLButton;
